<template>
  <div class="popup-form archive-popup">
    <div class="content-form-popup archive-popup-content">
      <div class="archive-popup-header">
        <button class="archive-close" type="button" aria-label="Zavrieť" @click="closePopup">
          <img class="filter-primary" src="@/images/modal-close.svg" alt=""/>
        </button>
        <div>
          <span class="archive-kicker">Archivácia klienta</span>
          <h2>Prečo službu nevyužil?</h2>
          <p>Vyberte hlavný obchodný dôvod. Pomôže nám presnejšie vyhodnocovať kvalitu leadov.</p>
        </div>
      </div>

      <div class="archive-choice-list">
        <button
          v-for="choice in primaryChoices"
          :key="choice.value"
          class="archive-choice"
          type="button"
          @click="selectReason(choice)"
        >
          <span class="archive-choice-icon" :class="`is-${choice.tone}`">{{ choice.icon }}</span>
          <span class="archive-choice-copy">
            <strong>{{ choice.label }}</strong>
            <small>{{ choice.description }}</small>
          </span>
          <span class="archive-choice-arrow">{{ choice.value === 'other_failure' ? '›' : '✓' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArchiveClientPopUp",
  props: {
    payload: Object,
  },
  data: () => ({
    primaryChoices: [
      {
        value: "service_not_needed",
        label: "Nepotrebujem službu",
        description: "Klient službu odmietol alebo ju nechce využiť.",
        icon: "×",
        tone: "neutral",
      },
      {
        value: "only_information",
        label: "Službu nepotrebujem teraz",
        description: "Pôvodne informatívny prepočet, riešenie odkladá.",
        icon: "◷",
        tone: "waiting",
      },
      {
        value: "brand_distrust",
        label: "Neverím značke",
        description: "Klient nemá dôveru v Bankári.sk alebo spôsob služby.",
        icon: "!",
        tone: "danger",
      },
      {
        value: "other_failure",
        label: "Iný dôvod neúspechu",
        description: "Vyberiete konkrétny detail v ďalšom kroku.",
        icon: "…",
        tone: "primary",
      },
    ],
  }),
  methods: {
    selectReason(choice) {
      if (choice.value === "other_failure") {
        this.$store.commit("popupManagerState/pushToPopupOrder", {
          type: null,
          payload: this.payload,
          component: "ArchiveClientDetailPopUp",
          rules: ["single"],
        });
        return;
      }
      this.finishArchive(choice.value);
    },
    finishArchive(reason) {
      this.$store.commit("popupManagerState/setPopupSuccessResult", {
        client: this.payload.client,
        reason,
      });
      this.closePopup();
    },
    closePopup() {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
};
</script>

<style scoped lang="scss">
.archive-popup-content {
  padding: 28px;
}

.archive-popup-header {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 14px;
  margin-bottom: 22px;
}

.archive-close {
  display: grid;
  width: 36px;
  height: 36px;
  padding: 0;
  place-items: center;
  border: 1px solid var(--app-border);
  border-radius: 11px;
  background: var(--app-surface-muted);
  cursor: pointer;
}

.archive-close img {
  width: 17px;
  height: 17px;
}

.archive-kicker {
  color: var(--app-primary);
  font-size: 9px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .08em;
}

.archive-popup h2 {
  margin: 3px 0 4px;
  color: var(--app-text);
  font-size: 20px;
  font-weight: 800;
}

.archive-popup p {
  max-width: 470px;
  margin: 0;
  color: var(--app-text-muted);
  font-size: 10px;
  line-height: 1.5;
}

.archive-choice-list {
  display: grid;
  gap: 9px;
}

.archive-choice {
  display: grid;
  width: 100%;
  min-height: 72px;
  padding: 11px 13px;
  grid-template-columns: 40px minmax(0, 1fr) 28px;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--app-border);
  border-radius: 13px;
  background: var(--app-surface-muted);
  color: var(--app-text);
  text-align: left;
  cursor: pointer;
  transition: border-color .18s ease, background .18s ease, transform .18s ease;
}

.archive-choice:hover {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
  transform: translateY(-1px);
}

.archive-choice-icon {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border-radius: 11px;
  background: var(--app-surface-strong);
  color: var(--app-text-muted);
  font-size: 16px;
  font-weight: 800;
}

.archive-choice-icon.is-primary { background: var(--app-primary-soft); color: var(--app-primary); }
.archive-choice-icon.is-waiting { background: rgba(242, 169, 59, .14); color: #d58b18; }
.archive-choice-icon.is-danger { background: rgba(239, 106, 112, .14); color: #df565d; }

.archive-choice-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.archive-choice-copy strong {
  font-size: 12px;
  font-weight: 800;
}

.archive-choice-copy small {
  color: var(--app-text-muted);
  font-size: 9px;
  line-height: 1.35;
}

.archive-choice-arrow {
  display: grid;
  width: 27px;
  height: 27px;
  place-items: center;
  border-radius: 9px;
  background: var(--app-surface);
  color: var(--app-primary);
  font-size: 17px;
  font-weight: 800;
}
</style>
